import React, { Component } from 'react';
import { roundigFormat } from '../libs/utils/Operations';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
//formato de cantidades
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
}

const renderTableBody = (headers, data, checkbox, openDocumentDetails) => {
    let body: "";

    body = data.map((register, index) => {

        let docDate = new Date(register.DocDate);
        let docDueDate = new Date(register.DocDueDate);

        docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
        docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());

        let DocCur = register?.DocCur || CURRENCY || '';
        let DocTotal = (!DocCur || DocCur === 'SOL')
            ? Number(register?.DocTotal || 0)
            : Number(register?.DocTotalFC || 0);

        DocTotal = Number.isFinite(DocTotal) ? DocTotal : 0;

        if (register.statusBorrador != 'W' && register.statusBorrador != 'Y') {
            return (
                <tr key={index}>
                    <td className="sticky-column">
                        <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2"
                            checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                    </td>
                    {headers[0].value && <td className="text-center" style={{ color: register.DocStatus === 'C' ? 'red' : 'black' }}>{register.DocStatus === 'O' ? "Abierto" : register.CANCELED === 'Y' ? 'Cancelado' : "Cerrado"}</td>}
                    {headers[12].value && <td className="text-center">{register.ReferenciaBorrador || 'Sin Referencia'}</td>}
                    {headers[13].value && <td className="text-center">{register.FechaCreacionBorrador ? moment(register.FechaCreacionBorrador).format("DD-MM-YYYY") : ''}</td>}
                    {headers[14].value && <td className="text-center">{register.CreateDate ? moment(register.CreateDate).format("DD-MM-YYYY") : ''}</td>}
                    {headers[1].value && <td className="text-center">{moment(docDate).format("DD-MM-YYYY")}</td>}
                    {headers[2].value && <td className="text-center">{register.ReqDate ? moment(new Date(register.ReqDate)).format("DD-MM-YYYY") : ''}</td>}
                    {headers[3].value && <td className="text-right font-weight-bold">{register.DocNum || ''}</td>}
                    {headers[4].value && <td>{register.U_RS_NivelReq || ''}</td>}
                    {headers[5].value && <td>{register.Sucursal || ''}</td>}
                    {headers[6].value && <td>{register.Departamento || ''}</td>}
                    {headers[7].value && <td>{register.ReqName || register.U_NAME || ''}</td>}
                    {headers[8].value &&
                        <td>{register.Comments === 0 || register.Comments === 'undefined' || register.Comments === undefined || register.Comments === '' || register.Comments === null ? "No hay comentarios" : register.Comments}</td>}
                    {headers[9].value &&
                        <td>{register.U_RS_PROYECTO || ''}</td>}
                    {headers[10].value && <td>{register.UserID || ''}</td>}
                    {headers[11].value && <td>{register.Series || ''}</td>}
                    <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDocumentDetails({ DocEntry: register.DocEntry, index })}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    </td>
                </tr>
            )
        }
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox"
                    onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[12].value && <td>{headers[12].title}</td>}
            {headers[13].value && <td>{headers[13].title}</td>}
            {headers[14].value && <td>{headers[14].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            {headers[8].value && <td>{headers[8].title}</td>}
            {headers[9].value && <td>{headers[9].title}</td>}
            {headers[10].value && <td>{headers[10].title}</td>}
            {headers[11].value && <td>{headers[11].title}</td>}

            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTablePurchaseRequest = (headers, data, checkbox, openDocumentDetails) => {

    return renderTable(headers, data, checkbox, openDocumentDetails);

}
